import { Paper, Tab, Tabs, TextField, Typography } from '@material-ui/core';
import type { StyledComponentProps } from '@material-ui/core/styles';
import Chart from 'components/Chart';
import ColoredFormattedNumber from 'components/ColoredFormattedNumber';
import Spin from 'components/Spin';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { lastGain } from 'store/Orbita/Dashboard/actions';

import styles from '../../styles';

import type { DispatchProp } from 'react-redux';

interface IProps extends DispatchProp<any>, StyledComponentProps {
  id: string;
  isFetching: boolean;
  producer: any;
  coproducer: any;
  affiliate: any;
}

class BarChart extends Component<IProps, any> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      data: '',
      tab: 0,
      dateType: '1',
    };
  }

  componentDidMount() {
    (async () => {
      try {
        await this.props.dispatch(lastGain());
        this.setGraphData(0);
      } catch (error) {
        //toast.error('Ops, erro no gráfico de conteúdos mais vendidos');
      }
    })();
  }

  setGraphData = (option: any) => {
    const { producer, coproducer, affiliate } = this.props;
    const { dateType } = this.state;
    const getSaturBlue = () => {
      let letters = '0123456789ABCDEF';
      let color = '#';
      for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    };

    let newData;
    switch (option) {
      case 1:
        newData = coproducer;
        break;
      case 2:
        newData = affiliate;
        break;
      case 0:
      default:
        newData = producer;
    }

    switch (dateType) {
      case '2':
        newData = newData.create;
        break;
      case '1':
      default:
        newData = newData.payment;
    }

    const coloredDatasets =
      newData.datasets &&
      newData.datasets.map((item: any) => {
        return {
          data: item.data,
          label: item.label,
          backgroundColor: getSaturBlue(),
        };
      });
    this.setState({
      data: {
        labels: newData && newData.labels,
        datasets: coloredDatasets,
      },
      tab: option,
    });
  };

  handleChange = (event: any, tab: any) => {
    this.setGraphData(tab);
  };

  onChangeDateType = (e: any) => {
    (async () => {
      await this.setState({ dateType: e.target.value });
      this.setGraphData(this.state.tab);
    })();
  };

  render() {
    const { classes, isFetching, id } = this.props;
    const { tab, data } = this.state;
    const options = {
      responsive: true,
      legend: {
        display: false,
      },
      scales: {
        xAxes: [
          {
            stacked: true,
          },
        ],
        yAxes: [
          {
            stacked: true,
          },
        ],
      },
    };

    const totalPerDay = (data: any, index: any) => {
      let total: number = 0;
      if (data && data.datasets && Array.isArray(data.datasets) && data.datasets.length) {
        let arrayValues = data.datasets.map((item: any) => item.data[index]);
        total += arrayValues.reduce((total: any, current: any) => total + current);
      }
      return total;
    };

    return (
      <Paper square={false} elevation={0} classes={{ root: classes.paper }}>
        <div className={classes.smallCard}>
          {isFetching ? (
            <Spin />
          ) : (
            <div>
              <div className={classes.cardHead}>
                <Typography variant='h6'>Ganho últimos 7 dias</Typography>
                <TextField
                  id='select-currency-native'
                  select
                  label=''
                  SelectProps={{ native: true }}
                  InputProps={{ disableUnderline: true }}
                  className={classes.textField}
                  value={this.state.dateType}
                  onChange={this.onChangeDateType}
                >
                  <option value={1}>Data de pagamento</option>
                  <option value={2}>Data de criação</option>
                </TextField>
              </div>
              <div className={classes.cardTab}>
                <Tabs value={tab} onChange={this.handleChange} classes={{ root: classes.tabsRoot2, indicator: classes.tabsIndicator2 }} centered>
                  <Tab classes={{ root: classes.tabRoot2 }} label={'Produtor'} />
                  <Tab classes={{ root: classes.tabRoot2 }} label={'Co-Produtor'} />
                  <Tab classes={{ root: classes.tabRoot2 }} label={'Afiliado'} />
                </Tabs>
              </div>
              <div className={classes.cardContent}>
                {data && data.labels && data.labels && Array.isArray(data.labels) && data.labels.length > 0 ? (
                  <div>
                    <div className={classes.cardGraph}>
                      <Chart id={id} type='bar' options={options} data={data} />
                    </div>
                    <div className={classes.cardLegends}>
                      {data.labels.map((item: any, i: any) => (
                        <div key={'product-bars-' + i} className={classes.legendsList}>
                          <span>{item}</span>
                          <strong>
                            <ColoredFormattedNumber value={totalPerDay(data, i)} />
                          </strong>
                        </div>
                      ))}
                    </div>
                  </div>
                ) : (
                  <div style={{ textAlign: 'center' }} className={classes.cardGraph}>
                    <span> Não há dados a serem mostrados </span>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </Paper>
    );
  }
}

function mapStateToPros(state: any) {
  const bs = state.orbita.Dashboard.lastGain || [];
  return {
    isFetching: state.orbita.Dashboard.lastGain.isFetching,
    producer: bs && bs.producer,
    coproducer: bs && bs.coproducer,
    affiliate: bs && bs.affiliate,
  };
}

export default connect(mapStateToPros)(styles(BarChart));
